import { PaymentDiscountType } from '@shared/payment-detail/entities/payment-detail';
import {
  discountPercentageCalculatedByTaxes, discountPercentageCalculatedByTotal
} from '@app/mappers/discount-percentage.mapper';

export function getPaymentDiscountType(
  strikethrough: number, total: number, discountAmount: number, strikethroughDiscount: number,
): PaymentDiscountType {
  return strikethrough && strikethroughDiscount && strikethrough !== total ? PaymentDiscountType.Strikethrough :
    discountAmount ? PaymentDiscountType.DiscountAmount : null;
}

export function getStrikethroughDiscount(totalDiscountInStrikethrough: number, totalDiscount: number): number {
  return totalDiscountInStrikethrough || totalDiscount || 0;
}

export function getPaymentDiscountAmount(
  strikethrough: number, total: number, discountAmount: number, strikethroughDiscount: number,
): number {
  const type = getPaymentDiscountType(strikethrough, total, discountAmount, strikethroughDiscount);
  switch (type) {
    case PaymentDiscountType.DiscountAmount:
      return discountAmount;
    case PaymentDiscountType.Strikethrough:
      return strikethroughDiscount;
    default:
      return 0;
  }
}

export function getPaymentPercentageCalculated(
  calculatedBytaxes: boolean, strikethrough: number, total: number, discountAmount: number,
  strikethroughDiscount: number, amount: number, taxes: number,
): number {
  const type = getPaymentDiscountType(strikethrough, total, discountAmount, strikethroughDiscount);
  switch (type) {
    case PaymentDiscountType.DiscountAmount:
      return calculatedBytaxes ? discountPercentageCalculatedByTaxes(discountAmount, amount, taxes) :
        discountPercentageCalculatedByTotal(discountAmount, total);
    case PaymentDiscountType.Strikethrough:
      return Math.round((1 - (total / strikethrough)) * 100);
    default:
      return 0;
  }
}

export function getPaymentDiscountStrikethroughValue(
  strikethrough: number, total: number, discountAmount: number, strikethroughDiscount: number,
  amount: number, taxes: number, fees: number, surcharges: number,
): number {
  const type = getPaymentDiscountType(strikethrough, total, discountAmount, strikethroughDiscount);
  switch (type) {
    case PaymentDiscountType.DiscountAmount:
      return amount + taxes + fees + surcharges;
    case PaymentDiscountType.Strikethrough:
      return strikethrough;
    default:
      return 0;
  }
}
